import React from "react";
import { Link } from "react-router-dom";

const PrivacyPage: React.FC = () => {
  return (
    <div className="container privacy-page">
      <h1>Privacy</h1>
      <p>
        Flixtor is a demo app for browsing public movie and TV metadata from{" "}
        <a
          href="https://www.themoviedb.org/"
          target="_blank"
          rel="noreferrer"
        >
          TMDB
        </a>
        . It does not host or stream video. API keys and usage should follow
        TMDB&apos;s terms.
      </p>
      <p>
        This page is a placeholder for a full privacy policy. Extend it with
        your analytics, cookies, and data practices if you deploy publicly.
      </p>
      <p>
        <Link to="/" className="text-secondary">
          ← Back to home
        </Link>
      </p>
    </div>
  );
};

export default PrivacyPage;
